module.exports = __webpack_public_path__ + "static/media/empty.3f67be2f.svg";